"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactVirtualized = require("react-virtualized");

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _Tiles = _interopRequireDefault(require("./Tiles"));

var InfiniteTiles = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InfiniteTiles, _Component);

  function InfiniteTiles(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InfiniteTiles);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InfiniteTiles).call(this, props));
    _this.state = {
      loaderKey: 1
    };
    _this.isRowLoaded = _this.isRowLoaded.bind((0, _assertThisInitialized2.default)(_this));
    _this.increaseLoaderKeyValue = _this.increaseLoaderKeyValue.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InfiniteTiles, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          tiles = _this$props.tiles,
          total = _this$props.total;

      if (tiles !== nextProps.tiles && total !== nextProps.total) {
        this.increaseLoaderKeyValue();
      }
    }
  }, {
    key: "increaseLoaderKeyValue",
    value: function increaseLoaderKeyValue() {
      var loaderKey = this.state.loaderKey;
      this.setState({
        loaderKey: loaderKey + 1
      });
    }
  }, {
    key: "isRowLoaded",
    value: function isRowLoaded(_ref) {
      var index = _ref.index;
      var tiles = this.props.tiles;
      return !this.hasMore() || index < tiles.count();
    }
  }, {
    key: "hasMore",
    value: function hasMore() {
      var _this$props2 = this.props,
          tiles = _this$props2.tiles,
          total = _this$props2.total;
      return tiles.count() < total;
    }
  }, {
    key: "getRowCount",
    value: function getRowCount() {
      var tiles = this.props.tiles;
      return this.hasMore() ? tiles.size + 1 : tiles.size;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          tiles = _this$props3.tiles,
          tileRenderer = _this$props3.tileRenderer,
          onLoadMoreImages = _this$props3.onLoadMoreImages;
      var loaderKey = this.state.loaderKey;
      return _react.default.createElement(_UIBox.default, {
        grow: 1,
        key: loaderKey,
        "data-test-id": "infinite-tiles"
      }, _react.default.createElement(_reactVirtualized.InfiniteLoader, {
        loadMoreRows: onLoadMoreImages,
        isRowLoaded: this.isRowLoaded,
        rowCount: this.getRowCount()
      }, function (_ref2) {
        var onRowsRendered = _ref2.onRowsRendered,
            registerChild = _ref2.registerChild;
        return _react.default.createElement(_reactVirtualized.AutoSizer, null, function (_ref3) {
          var width = _ref3.width,
              height = _ref3.height;
          return _react.default.createElement(_Tiles.default, {
            key: registerChild,
            height: height,
            width: width,
            tiles: tiles,
            tileRenderer: tileRenderer,
            onRowsRendered: onRowsRendered
          });
        });
      }));
    }
  }]);
  return InfiniteTiles;
}(_react.Component);

exports.default = InfiniteTiles;
InfiniteTiles.propTypes = {
  tiles: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  total: _propTypes.default.number.isRequired,
  tileRenderer: _propTypes.default.func.isRequired,
  onLoadMoreImages: _propTypes.default.func.isRequired
};
module.exports = exports.default;